exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fees-disbursements {\n  padding-top: 15px;\n  padding-bottom: 15px; }\n  .fees-disbursements .table-title {\n    padding: 7px;\n    font-size: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-fees-disbursements/claim-fees-disbursements.component.scss
// module id = ../../../../../src/app/claim/claim-fees-disbursements/claim-fees-disbursements.component.scss
// module chunks = main